import { firebaseDB } from '@/config/firebaseConfig'
const state = {
  startDate: null,
  stopDate: null,
  reportData: [],
  customerReportData: []
}

const mutations = {
  'SET_DATE_RATE' (state, data) {
    state.startDate = data.startDate
    state.stopDate = data.stopDate
  },
  'SET_REPORT_DATA' (state, data) {
    state.reportData = data
  },
  'SET_CUSTOMER_REPORT_DATA' (state, data) {
    state.customerReportData = data
  }
}

const actions = {
  setDateRange ({ commit }, payload) {
    commit('SET_DATE_RATE', payload)
  },
  async getReport ({ commit, getters }) {
    const result = await firebaseDB().ref('orders/' + getters.shopId).once('value')
    if (!result.val()) {
      commit('SET_REPORT_DATA', [])
      return
    }
    const customers = Object.values(result.val())
    let orders = []
    if (customers !== null) {
      customers.forEach(customer => {
        let customerOrders = Object.values(customer)
        customerOrders.forEach(order => {
          orders.push(order)
        })
      })
      commit('SET_REPORT_DATA', orders)
    }
  },
  async getCustomerReport ({ commit, getters }) {
    const result = await firebaseDB().ref('orders/' + getters.shopId).once('value')
    if (!result.val()) {
      commit('SET_CUSTOMER_REPORT_DATA', [])
      return
    }
    const customers = Object.values(result.val())
    let orders = []
    if (customers !== null) {
      customers.forEach(customer => {
        let customerOrders = Object.values(customer)
        customerOrders.forEach(order => {
          orders.push(order)
        })
      })
      commit('SET_REPORT_DATA', orders)
    }
  }
}

const getters = {
  reportData: state => state.reportData
}

export default {
  state,
  mutations,
  actions,
  getters
}
